import SupportPage from "./ui/SupportPage.vue";
export default SupportPage;
